import {Control} from "ol/control";
import {addWMTSLayer} from "@/helpers/ol-wmts-helper";
import $ from "jquery";

let hasLuchtfoto = false
let hasDefaultMap = false
export class RotateNorthControl extends Control {
    /**
     * @param {Object} [opt_options] Control options.
     */
    constructor(opt_options) {
        const options = opt_options || {};

        const button = document.createElement('button');
        button.className = 'btnLuchtFoto'
        button.type = 'button'
        button.style.backgroundImage = 'url("assets/img/lufo.png"'
        button.dataset.layer = 'kaart'

        const element = document.createElement('div');
        element.className = 'ol-switch-layer ol-unselectable ol-control';
        element.appendChild(button);

        super({
            element: element,
            target: options.target,
        });

        button.addEventListener('click', this.handleRotateNorth.bind(this), false);
    }

    handleRotateNorth(event, target) {

        const map = window.map

        map.getLayers().forEach(layer => {

            if(layer.get('name') === 'water') {
                hasDefaultMap = true
                layer.setVisible(!layer.getVisible())

                if(layer.getVisible()) {
                    $('.btnLuchtFoto').css('background-image', 'url("assets/img/lufo.png"')
                }
            }

            if(layer.get('name') === 'Actueel_ortho25') {
                hasLuchtfoto = true
                layer.setVisible(!layer.getVisible())

                if(layer.getVisible()) {
                    $('.btnLuchtFoto').css('background-image', 'url("assets/img/kaart.png"')
                }
            }
        });

        if(!hasLuchtfoto) {
            const layer = {}
            layer.Layer =  'Actueel_ortho25'
            layer.Url =  'https://service.pdok.nl/hwh/luchtfotorgb/wmts/v1_0/'

            addWMTSLayer(layer, true) //('https://service.pdok.nl/hwh/luchtfotorgb/wms/v1_0?', 'Actueel_ortho25', 'luchtfoto'))
            $('.btnLuchtFoto').css('background-image', 'url("assets/img/kaart.png"')
        }
    }
}
